// extracted by mini-css-extract-plugin
module.exports = {"infoLink":"InfoLink_infoLink_3mIa1","bigText":"InfoLink_bigText_Wecwk"};